module.exports = __webpack_public_path__ + "static/media/drawing.adff22a7.jpg";